import {
  delFavorites,
  getFavoritesDetail,
  sortFavorites,
} from '@/pages/opinion/services/favorites';
import { arrayToObj } from '@/pages/opinion/utils';
import React, { useEffect, useState } from 'react';
import { Modal } from 'tea-component';
import { useIntl } from 'umi';

export function useDeleteFavoritePage({ gameInfo, id }: any) {
  const { formatMessage } = useIntl();
  const handleRemove = async (callback: () => void) => {
    const yes = await Modal.confirm({
      message: (
        <span className="dbh-sure-text">
          {formatMessage({ id: 'Are you sure to remove from Favorites?' })}
        </span>
      ),
      okText: formatMessage({ id: 'Confirm' }),
      cancelText: formatMessage({ id: 'Cancel' }),
    });

    if (yes) {
      // 请求接口删除
      delFavorites({
        edition_unified_id: gameInfo.edition_unified_id,
        id: Number(id),
      }).then(() => {
        callback();
      });
    }
  };

  return {
    handleRemove,
  };
}

export function useMenuOperateInfo({
  menuList,
  changeMenuFilterInfo,
  menuFilterInfo,
  setMenuFilterInfo,
}: any) {
  const [mainMenuList, setMainMenuList] = useState([]);
  const [favoritesMenuList, setFavoritesMenuList] = useState<Array<any>>([]);
  useEffect(() => {
    const favoritesMenu = menuList.find(
      (item: any) => item.name_en === 'Favorite Page',
    );

    if (favoritesMenu) {
      setMainMenuList(
        menuList.filter((item: any) => item.name_en !== 'Favorite Page'),
      );
      setFavoritesMenuList(favoritesMenu.opinion_list || []);
    } else {
      setMainMenuList(menuList);
      setFavoritesMenuList([]);
    }
  }, [menuList]);

  const deleteCallback = (id: string) => {
    setFavoritesMenuList(
      favoritesMenuList.filter((item: any) => item.id != id),
    );
  };

  // 存在修改和添加两种情况
  const addCallback = (info: any) => {
    const itemIndex = favoritesMenuList.findIndex((item) => item.id == info.id);
    let sort = 1;
    if (itemIndex === -1) {
      // 取最后一个元素的sort 并 +1作为新菜单的sort
      sort =
        Number(favoritesMenuList?.[favoritesMenuList.length - 1]?.sort || 0) +
        1;
      setFavoritesMenuList([
        ...favoritesMenuList,
        {
          ...info,
          sort,
        },
      ]);
    } else {
      favoritesMenuList[itemIndex] = {
        ...favoritesMenuList[itemIndex],
        ...info,
      };
      sort = favoritesMenuList[itemIndex].sort;
      setFavoritesMenuList([...favoritesMenuList]);
    }

    changeMenuFilterInfo({ ...info, sort: Number(sort) });
  };

  const sortCallback = (
    id: number,
    sort: 'up' | 'down',
    edition_unified_id: string,
  ) => {
    const copyFavoritesMenuList = JSON.parse(JSON.stringify(favoritesMenuList));
    const index = copyFavoritesMenuList.findIndex((item) => item.id === id);
    const otherIndex = sort === 'up' ? index - 1 : index + 1;

    if (otherIndex === -1 || otherIndex === copyFavoritesMenuList.length) {
      return;
    }

    const sortValue = copyFavoritesMenuList[index].sort;
    copyFavoritesMenuList[index].sort = copyFavoritesMenuList[otherIndex].sort;
    copyFavoritesMenuList[otherIndex].sort = sortValue;
    copyFavoritesMenuList.sort((a, b) => a.sort - b.sort);

    sortFavorites({
      edition_unified_id,
      sorts: copyFavoritesMenuList.map((item) => ({
        id: Number(item.id),
        sort: Number(item.sort),
      })),
    }).then(() => {
      const sortMenuFilterInfo: any = {};
      copyFavoritesMenuList?.map(({ id, sort }: any) => {
        sortMenuFilterInfo[id] = {
          ...menuFilterInfo[id],
          sort,
        };
      });
      setMenuFilterInfo(sortMenuFilterInfo);
      setFavoritesMenuList([...copyFavoritesMenuList]);
    });
  };

  return {
    mainMenuList,
    favoritesMenuList,
    deleteCallback,
    addCallback,
    sortCallback,
  };
}

export function useGetMenuFilterInfo({ gameInfo }: any) {
  const [loading, setLoading] = useState(false);
  const [menuFilterInfo, setMenuFilterInfo] = useState<any>([]);
  useEffect(() => {
    if (!gameInfo.edition_unified_id) return;
    setLoading(true);
    getFavoritesDetail({
      edition_unified_id: gameInfo.edition_unified_id,
      ids: [],
    })
      .then((data: any) => {
        const menuFilterInfo = arrayToObj(data, 'id');
        setMenuFilterInfo(menuFilterInfo);
      })
      .catch(() => {})
      .finally(() => {
        setLoading(false);
      });
  }, [gameInfo]);

  const changeMenuFilterInfo = (info: any) => {
    setMenuFilterInfo({
      ...menuFilterInfo,
      [info.id]: {
        ...info,
        report_name: info.name_en,
      },
    });
  };

  return {
    changeMenuFilterInfo,
    menuFilterInfo,
    loading,
    setMenuFilterInfo,
  };
}
